import { makeObservable, computed, action, observable } from 'mobx'
import Checklist from '../../../../Checklist'
import Member from '../../../../../iam/models/Member'
import Job, { Collaborator } from '../../../../Job'
import JobStore from '../../../../JobStore'
import { AlertFactory } from '../../../../../alerts/Alert'
import ModalViewModel from '../../../../../infra/ModalViewModel'
import { task } from 'mobx-task'

export default class InfoGatheringCardViewModel {
  completeStepConfirmDialog = new ModalViewModel()

  completeAsAdmin = false

  constructor(
    private job: Job,
    private newAlert: AlertFactory,
    private checklist: () => Checklist | undefined,
    private jobWorkspaceMember: Member,
    private currentUserCollaborator: Collaborator | null,
    private jobStore: JobStore
  ) {
    makeObservable(this, {
      canCompleteInfoGathering: computed,
      isAdmin: computed,
      requestedPro: computed,
      isClient: computed,
      complete: action.bound,
      completeAsAdmin: observable,
    })
  }

  complete = task.resolved(async () => {
    try {
      await this.jobStore.completeInfoGathering(
        this.job.id,
        this.completeAsAdmin
      )
    } catch (error) {
      this.newAlert().fromError(error).show()
    } finally {
      this.completeStepConfirmDialog.close()
    }
  })

  get isAdmin() {
    return this.jobWorkspaceMember.hasSomePermissions('ADMIN_JOB_UPDATE')
  }

  get isClient() {
    return this.currentUserCollaborator?.type === 'CLIENT'
  }

  get canCompleteInfoGathering() {
    const checklist = this.checklist()
    if (this.isAdmin) {
      return true
    }
    return (
      this.currentUserCollaborator?.type === 'CLIENT' &&
      checklist?.sections.every((s) => s.requirementsCompleted)
    )
  }

  get requestedPro() {
    return this.job.requestedPro
  }
}
